export default __webpack_public_path__ + "static/media/roadmap-line.403c6624.svg";